export default __webpack_public_path__ + "static/media/Group52.0a8894e0.svg";